import { atom } from 'jotai';

// export const hideAllPaymentsAtom = atom<boolean>(false);

export const orderSummaryTotalPriceAtom = atom<number>(0);
